export default __webpack_public_path__ + "static/media/oslo.a636286d.png";